import React, { useContext, useEffect, useRef, useState } from 'react';

import { AppContext } from '~/contexts/AppContext';

import styled from 'styled-components';
import { animated, useSpring } from 'react-spring';
import ResultSlide from './ResultSlide';
import TotalResultSlide from './slides/MajorityResultSlide';
import { GroupResult } from '~/types';
import { SliderAnimationState } from '../SliderPanel';
import StaticSlider from '~/components/StaticSlider';

const RatingResultStyle = styled(animated.div)`
    width: calc(100% - 60px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin: 20px auto;
`;

const ResultContainer = styled.div`
    flex: 1;
    height: calc(100% - 25px);
    display: flex;
    align-items: center;
    justify-content: center;
`;

interface RatingResultProps {
    ratingValue: number;
    ratingId: number | null;
    sliderAnimationState: SliderAnimationState;
    onAnimationComplete: () => void;
    loadingResults: { [groupString: string]: boolean };
    groupResults: { [groupString: string]: GroupResult };
    setReferenceRating: (referenceRating: number | null, referenceColor: string | null) => void;
    isFirstSlide?: boolean;
}

interface RatingResultState {
    fadeInComplete: boolean;
}

const MajorityResult: React.FC<RatingResultProps> = (props) => {

    const { topicData } = useContext(AppContext)!;

    const [state, setState] = useState<RatingResultState>(() => ({
        fadeInComplete: false,
    }));

    const [resultContainerStyle] = useSpring(() => ({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duation: 600 },
        onRest: () => {
            setState(prevState => ({...prevState, fadeInComplete: true }));
        }
    }));

    useEffect(() => {
        if (props.isFirstSlide) {
            const groupResult: GroupResult | undefined = props.groupResults['majority'];

            if (groupResult)
                props.setReferenceRating(groupResult.rating, groupResult.color);
            else
                props.setReferenceRating(null, null);
        }
    }, [props.groupResults, props.isFirstSlide]);

    return (
        <RatingResultStyle style={resultContainerStyle}>
            <StaticSlider 
                userRating={props.ratingValue}
                majorityRating={props.groupResults.majority?.rating || null}
                showReferenceLine={true}
                referenceLineColor={props.groupResults.majority?.color || '#000000'}
                hideSlider={props.isFirstSlide}
            />
            <ResultContainer>
                {topicData?.topic.pvtShowPeopleStats && (
                    <ResultSlide 
                        index={0} 
                        loadingResults={props.loadingResults.majority}
                        groupResult={props.groupResults.majority}
                        currentSlide={0} 
                        slideClicked={() => {}}
                    >
                        <TotalResultSlide
                            ratingValue={props.ratingValue}
                            groupResult={props.groupResults.majority}
                            fadeInComplete={state.fadeInComplete}
                            onAnimationComplete={props.onAnimationComplete}
                        />
                    </ResultSlide>
                )}
            </ResultContainer>
        </RatingResultStyle>
    );
};

export default MajorityResult;